import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import WarningIcon from "@mui/icons-material/Warning";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  outline: "none",
  textAlign: "center",
};

const ConfirmationPopup = ({
  open,
  onClose,
  onConfirm,
  title,
  button = true,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "warning",
}) => {
  const IconComponent = variant === "warning" ? WarningIcon : CheckCircleIcon;
  const iconColor = variant === "warning" ? "warning.main" : "success.main";

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-modal-title"
      aria-describedby="confirmation-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <IconComponent
            color={variant}
            sx={{ fontSize: 60, color: iconColor, mb: 1 }}
          />
          <div
            id="confirmation-modal-title"
            className="popup-title"
            style={{ fontWeight: 600, color: "var(--color-text-dark)", textAlign: "center" }}
          >
            {title}
          </div>
          <div
            id="confirmation-modal-description"
            className="popup-subtitle"
            style={{ color: "var(--color-text-light)", marginBottom: "24px", textAlign: "center" }}
          >
            {message}
          </div>
          {button && (
            <Box
              sx={{
                display: "flex",
                gap: 2,
                width: "100%",
                justifyContent: "center",
              }}
            >
              <Button
                variant="outlined"
                onClick={onClose}
                sx={{ minWidth: 100 }}
              >
                {cancelText}
              </Button>
              <Button
                variant="contained"
                onClick={onConfirm}
                color={variant === "warning" ? "warning" : "success"}
                sx={{ minWidth: 100 }}
              >
                {confirmText}
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationPopup;
